module.exports = __webpack_public_path__ + "img/assessment-active.8eaf73a3.svg";